import noUiSlider from 'nouislider';

export default class RangeSlider {
  constructor(rootEl, options) {
    this.options = options;
    this.rootEl = rootEl;
    this.selectedMin = rootEl.dataset.selectedMin;
    this.selectedMax = rootEl.dataset.selectedMax;
    this.init();
  }

  init() {
    this.createInstance();
    this.checkSelectedState();
  }

  createInstance() {
    this.slider = noUiSlider.create(this.rootEl, this.options);
  }

  checkSelectedState() {
    if (this.selectedMin && this.selectedMax) {
      this.slider.set([parseInt(this.selectedMin, 10), parseInt(this.selectedMax, 10)]);
    } else if (this.selectedMin) {
      this.slider.set(parseInt(this.selectedMin, 10), null);
    } else if (this.selectedMax) {
      this.slider.set(null, parseInt(this.selectedMax, 10));
    }
  }
}
